module.exports = __webpack_public_path__ + "img/Weapon_sword_01_mesh.7599cc0e.png";